import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  .react-modal-sheet-backdrop {\n    background-color: rgba(0, 0, 0, 0.5) !important;\n    ",
        "\n    transition: background-color 0.3s;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  all: unset;\n  /* position: absolute; */\n  border: none;\n  display: block;\n  background: transparent;\n  top: 28px;\n  right: 28px;\n  font-size: 0;\n  width: 24px;\n  height: 24px;\n  cursor: pointer;\n  margin-top: 4px;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  padding: 72px 0;\n\n  > div {\n    border-radius: 8px;\n    display: flex;\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        "\n  main {\n    padding: 28px;\n    &::-webkit-scrollbar {\n      width: 5px;\n      background-color: transparent;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      border-radius: 32px;\n      background: ",
        ";\n    }\n\n    height: auto;\n    flex-grow: 1;\n    overflow-y: auto;\n    overflow-x: hidden;\n    width: 520px;\n\n    h4 {\n      display: flex;\n      justify-content: space-between;\n\n      font-size: 20px;\n      font-weight: 700;\n      line-height: 1.5;\n      letter-spacing: -0.2px;\n      margin-bottom: 8px;\n    }\n\n    p {\n      color: ",
        ";\n      font-size: 16px;\n      font-weight: 600;\n      line-height: 1.5;\n      letter-spacing: -0.16px;\n      margin-bottom: 12px;\n    }\n\n    dl {\n      display: flex;\n      flex-wrap: wrap;\n      margin-bottom: 4px;\n\n      dt,\n      dd {\n        font-size: 16px;\n        line-height: 1.5;\n        letter-spacing: -0.16px;\n        margin-bottom: 0;\n\n        b,\n        .text-blue {\n          color: ",
        ";\n        }\n        b.text-green {\n          color: ",
        ";\n        }\n\n        b {\n          white-space: pre;\n        }\n      }\n    }\n\n    .pass-summary {\n      dl {\n        dd {\n          margin-left: 4px;\n        }\n\n        dt,\n        dd {\n          color: ",
        ";\n        }\n\n        dd.style-zero {\n          margin-left: 0;\n        }\n      }\n    }\n\n    .pass-range {\n      dl {\n        dt {\n          color: ",
        ";\n          width: 100px;\n        }\n\n        dd {\n          display: flex;\n          flex: 1;\n          color: ",
        ";\n        }\n      }\n    }\n\n    .pass-detail {\n      ul {\n        li {\n          color: ",
        ";\n          font-size: 16px;\n          line-height: 1.5;\n          letter-spacing: -0.16px;\n          margin-bottom: 4px;\n          white-space: break-spaces;\n        }\n      }\n    }\n  }\n\n  .ant-divider {\n    margin: 28px 0;\n  }\n\n  @media (max-width: 768px) {\n    main {\n      width: unset;\n      text-align: left;\n      padding: 0;\n\n      .pass-detail {\n        ul {\n          li {\n            font-size: 14px;\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  position: sticky;\n  bottom: 0;\n  background-color: ",
        ";\n  padding: 20px 28px;\n  gap: 8px;\n  border-radius: 8px;\n\n  button {\n    width: 100%;\n  }\n\n  @media (max-width: 768px) {\n    padding: 20px 0;\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Icon from "@/components/icon/Icon";
import { Close, Sizes } from "@/components/icon/IconList";
import Modal from "@/components/modal/Modal";
import { useAuthStore } from "@/lib/auth/AuthStore";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { numberFormatter } from "@/lib/utils";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { PASSES_LANDING, PASSES_ORDER } from "@/settings/constant";
import { Button } from "@bookips/solvook-ui-library";
import { Typography } from "@mui/material";
import { Divider } from "antd";
import { useRouter } from "next/router";
import { useCallback, useMemo } from "react";
import Sheet from "react-modal-sheet";
import { TicketDeductionMethod } from "src/api/membership";
import styled from "styled-components";
import LoginDialog from "../../store/loginDialog";
import usePassStore from "../../store/pass";
import AnchorDrawer from "../modal/AnchorDrawer";
import { getPassScope, isCategoryIncludesExpert } from "./getPassScope";
const PassInfoSheet = styled(Sheet).withConfig({
    componentId: "sc-94c74eb2-0"
})(_templateObject(), (props)=>!props.isOpen && "background-color: transparent;");
export const PassInfoModal = (param)=>{
    let { ctaAction  } = param;
    const { isMobile  } = useWindowDimensions();
    const isPassInfoModal = usePassStore((state)=>state.isPassInfoModal);
    const closePassInfoModal = usePassStore((state)=>state.closePassInfoModal);
    //모바일의 경우 바텀시트
    if (!isMobile) return /*#__PURE__*/ _jsx(PassInfoModalWrapper, {
        depth: 1008,
        open: isPassInfoModal,
        onClose: closePassInfoModal,
        disableOutsideClick: false,
        children: /*#__PURE__*/ _jsx(PassInfoModalContents, {
            ctaAction: ctaAction
        })
    });
    return /*#__PURE__*/ _jsx(AnchorDrawer, {
        anchor: "bottom",
        open: isPassInfoModal,
        onClose: ()=>{
            closePassInfoModal();
        },
        children: /*#__PURE__*/ _jsx(AnchorDrawer.Contents, {
            children: /*#__PURE__*/ _jsx(PassInfoModalContents, {
                ctaAction: ctaAction
            })
        })
    });
};
const PassInfoModalContents = (param)=>{
    let { ctaAction  } = param;
    var _selectedPass_remainAmount, _selectedPass_availableAmount;
    const router = useRouter();
    const { isLoggedIn  } = useAuthStore();
    const { openLoginDialog  } = LoginDialog();
    const setIsPassInfoModal = usePassStore((state)=>state.closePassInfoModal);
    const selectedPass = usePassStore((state)=>state.selectedPass);
    const purchasePass = usePassStore((state)=>state.purchasePass);
    const isOrderPage = router.pathname.startsWith(PASSES_LANDING) //구매페이지 일경우
    ;
    const isPassPage = router.pathname === PASSES_LANDING //이용권 페이지 일경우
    ;
    const isAmountPassType = (selectedPass === null || selectedPass === void 0 ? void 0 : selectedPass.deductionMethod) === TicketDeductionMethod.AMOUNT || false;
    const onPurchase = useCallback(()=>{
        mixpanelEvent("Purchase Button Clicked", {
            "Product Categories": purchasePass.category,
            "Product ID": purchasePass.id,
            "Product Title": purchasePass.title,
            "Product Price": purchasePass.price
        });
        if (!isLoggedIn) {
            setIsPassInfoModal();
            openLoginDialog();
            return;
        }
        router.push("".concat(PASSES_ORDER, "?id=").concat(purchasePass.id));
        setIsPassInfoModal();
    }, [
        isLoggedIn,
        purchasePass
    ]);
    const filterPassScope = useMemo(()=>{
        if (selectedPass === null) return [];
        return getPassScope(selectedPass).filter((scope)=>{
            return scope.value !== "";
        });
    }, [
        selectedPass
    ]);
    if (!selectedPass) return null;
    var _selectedPass_availableCount;
    return /*#__PURE__*/ _jsxs(PassInfoModalContainer, {
        children: [
            /*#__PURE__*/ _jsxs("main", {
                children: [
                    /*#__PURE__*/ _jsxs("h4", {
                        children: [
                            selectedPass.title,
                            /*#__PURE__*/ _jsx(CloseButton, {
                                onClick: setIsPassInfoModal
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "pass-summary",
                        children: isOrderPage ? /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsxs("dl", {
                                    children: [
                                        selectedPass.isNoCountLimit ? "" : /*#__PURE__*/ _jsx("dt", {
                                            children: isCategoryIncludesExpert(selectedPass.category) ? "총 사용 가능 문제 수 :" : isAmountPassType ? "총 사용 가능 금액 : " : "총 사용 가능 횟수 : "
                                        }),
                                        selectedPass.isNoCountLimit ? /*#__PURE__*/ _jsx("dd", {
                                            className: "style-zero",
                                            children: /*#__PURE__*/ _jsx(Typography, {
                                                variant: "subtitle1",
                                                color: "secondary.main",
                                                children: "사용범위 내 무제한"
                                            })
                                        }) : /*#__PURE__*/ _jsx("dd", {
                                            children: "".concat(isCategoryIncludesExpert(selectedPass.category) ? selectedPass.isExpertUnLimited ? "무제한" : "".concat(numberFormatter(selectedPass.availableCount), "개") : isAmountPassType ? "".concat(numberFormatter(selectedPass.availableAmount), "원") : "".concat(numberFormatter(selectedPass.availableCount), "회"))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("dl", {
                                    children: [
                                        /*#__PURE__*/ _jsxs("dt", {
                                            children: [
                                                "사용 기간 : ",
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("dd", {
                                            children: " 결제일로부터 ".concat(selectedPass.period, "일간")
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsxs("dl", {
                                    children: [
                                        /*#__PURE__*/ _jsx("dt", {
                                            children: /*#__PURE__*/ _jsx("b", {
                                                className: isCategoryIncludesExpert(selectedPass.category) ? "text-green" : "text-blue",
                                                children: selectedPass.isNoCountLimit ? "" : isCategoryIncludesExpert(selectedPass.category) ? "남은 문제 수 : " : "남은 ".concat(isAmountPassType ? "금액 " : "횟수 ", ": ")
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("dd", {
                                            className: "style-zero",
                                            children: selectedPass.isNoCountLimit ? /*#__PURE__*/ _jsx("b", {
                                                children: "사용범위 내 무제한"
                                            }) : /*#__PURE__*/ _jsx("b", {
                                                className: isCategoryIncludesExpert(selectedPass.category) ? "text-green" : "text-blue",
                                                children: "".concat(isCategoryIncludesExpert(selectedPass.category) ? selectedPass.isExpertUnLimited ? "무제한" : "".concat(numberFormatter(selectedPass.availableCount), "개") : isAmountPassType ? "".concat(((_selectedPass_remainAmount = selectedPass.remainAmount) === null || _selectedPass_remainAmount === void 0 ? void 0 : _selectedPass_remainAmount.toLocaleString()) || 0, "원") : "".concat(numberFormatter(selectedPass.remainCount) || 0, "회"))
                                            })
                                        })
                                    ]
                                }),
                                !selectedPass.isNoCountLimit && /*#__PURE__*/ _jsx("dl", {
                                    children: /*#__PURE__*/ _jsxs("dd", {
                                        className: "style-zero",
                                        children: [
                                            isCategoryIncludesExpert(selectedPass.category) ? "총 사용 가능 문제 수 : " : "총 사용 가능 ".concat(isAmountPassType ? "금액" : "횟수", " : "),
                                            isCategoryIncludesExpert(selectedPass.category) && selectedPass.isExpertUnLimited ? "무제한" : "".concat(isAmountPassType ? ((_selectedPass_availableAmount = selectedPass.availableAmount) === null || _selectedPass_availableAmount === void 0 ? void 0 : _selectedPass_availableAmount.toLocaleString()) || 0 : (_selectedPass_availableCount = selectedPass.availableCount) !== null && _selectedPass_availableCount !== void 0 ? _selectedPass_availableCount : 0).concat(isCategoryIncludesExpert(selectedPass.category) ? "개" : isAmountPassType ? "원" : "회")
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("dl", {
                                    children: /*#__PURE__*/ _jsxs("dd", {
                                        className: "style-zero",
                                        children: [
                                            "남은 기간 : ",
                                            selectedPass.remainDay,
                                            "일 (",
                                            selectedPass.startedAt,
                                            " ~",
                                            " ",
                                            selectedPass.expiredAt,
                                            ")"
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(Divider, {}),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "pass-range",
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                children: "이용권 사용범위"
                            }),
                            filterPassScope.map((scope, idx)=>/*#__PURE__*/ _jsxs("dl", {
                                    children: [
                                        /*#__PURE__*/ _jsx("dt", {
                                            children: scope.type
                                        }),
                                        /*#__PURE__*/ _jsx("dd", {
                                            children: scope.value
                                        })
                                    ]
                                }, "scope-" + idx))
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Divider, {}),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "pass-detail",
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                children: "이용권 상세정보"
                            }),
                            /*#__PURE__*/ _jsx("ul", {
                                children: selectedPass.descriptionList.map((des, idx)=>/*#__PURE__*/ _jsxs("li", {
                                        children: [
                                            des,
                                            "\xa0"
                                        ]
                                    }, "description-" + idx))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(FooterContainer, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        onClick: ()=>{
                            mixpanelEvent("Guide Button Clicked", {
                                "Guide Categories": "Product Detail",
                                "Product ID": selectedPass.id,
                                "Product Title": selectedPass.title,
                                "Guide URL": selectedPass.category.includes("expert") ? "https://solvookguide.oopy.io/expert" : "https://solvookguide.oopy.io/78b924d5-140f-4475-bd9b-d13d99bedb2b"
                            });
                            if (selectedPass.category.includes("expert")) {
                                window.open("https://solvookguide.oopy.io/expert", "_blank");
                            } else {
                                window.open("https://solvookguide.oopy.io/78b924d5-140f-4475-bd9b-d13d99bedb2b", "_blank");
                            }
                        },
                        variant: "strokeSecondary",
                        size: "large",
                        label: "이용방법 보기"
                    }),
                    isPassPage ? /*#__PURE__*/ _jsx(Button, {
                        onClick: ()=>{
                            if (ctaAction) {
                                ctaAction();
                            } else {
                                onPurchase();
                            }
                        },
                        variant: "solid",
                        size: "large",
                        label: "구매하기"
                    }) : /*#__PURE__*/ _jsx(Button, {
                        onClick: setIsPassInfoModal,
                        variant: "solid",
                        size: "large",
                        label: "확인"
                    })
                ]
            })
        ]
    });
};
const CloseButton = (param)=>{
    let { onClick  } = param;
    return /*#__PURE__*/ _jsx(CloseButtonContainer, {
        onClick: onClick,
        children: /*#__PURE__*/ _jsx(Icon, {
            icon: Close,
            size: Sizes.medium
        })
    });
};
const CloseButtonContainer = styled.button.withConfig({
    componentId: "sc-94c74eb2-1"
})(_templateObject1());
const PassInfoModalWrapper = styled(Modal).withConfig({
    componentId: "sc-94c74eb2-2"
})(_templateObject2());
export const PassInfoModalContainer = styled.div.withConfig({
    componentId: "sc-94c74eb2-3"
})(_templateObject3(), (props)=>props.theme.new.colors.sol_gray_300, (props)=>props.theme.new.colors.sol_gray_700, (props)=>props.theme.new.colors.sol_blue_500, (props)=>props.theme.new.colors.sol_mint_400, (props)=>props.theme.new.colors.sol_gray_500, (props)=>props.theme.new.colors.sol_gray_300, (props)=>props.theme.new.colors.sol_gray_700, (props)=>props.theme.new.colors.sol_gray_500);
const FooterContainer = styled.div.withConfig({
    componentId: "sc-94c74eb2-4"
})(_templateObject4(), (props)=>props.theme.new.colors.white);
